<template>
  <b-container fluid class="sentenza">

    <loading :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"></loading>

    <b-row>
      <b-col sm="12">
        <b-row>
          <b-col sm="2" cols="6" class="py-3 text-left d-none d-sm-block">
            <router-link :to="{ name: 'Newsletter', params: { materia: $route.params.codiceOggetto, testo: testoRicerca } }">
              <b-button variant="info">Aggiornami</b-button>
            </router-link>
          </b-col>
          <b-col sm="2" cols="6" class="py-3 text-left">
            <router-link v-if="showPreviousSentenza" :to="{ name: 'Sentenza', params: { 
                      ...previousSentenzaParams, 
                      searchText: this.searchText,
                      searchOptions: this.searchOptions } }">
              <b-button variant="success">
                <font-awesome-icon icon="arrow-left" />
                Sentenza precedente
              </b-button>
            </router-link>
          </b-col>
          <b-col sm="4" class="d-none d-sm-block">
            <p class="text-muted mt-2">Sentenza n. {{numSentenza}} di {{totSentenze}}</p>
          </b-col>
          <b-col sm="2" cols="6" class="py-3 text-right">
            <router-link v-if="showNextSentenza" :to="{ name: 'Sentenza', params: { 
                      ...nextSentenzaParams, 
                      searchText: this.searchText,
                      searchOptions: this.searchOptions } }">
              <b-button variant="success">
                Sentenza successiva
                <font-awesome-icon icon="arrow-right" />
              </b-button>
            </router-link>
          </b-col>
          <b-col sm="2" class="py-3 text-right d-none d-sm-block">
            <router-link :to="{ name: 'Search', params: { scrollY: $route.params.scrollY } }">
              <b-button variant="danger">Chiudi</b-button>
            </router-link>
          </b-col>
        </b-row>
        <b-row class="d-flex d-sm-none">
          <b-col cols="12">
            <p class="text-muted mt-2">Sentenza n. {{numSentenza}} di {{totSentenze}}</p>
          </b-col>
          <b-col cols="6" class="py-3 text-left">
            <router-link :to="{ name: 'Newsletter', params: { materia: $route.params.codiceOggetto, testo: testoRicerca } }">
              <b-button variant="info">Aggiornami</b-button>
            </router-link>
          </b-col>
          <b-col cols="6" class="py-3 text-right">
            <router-link :to="{ name: 'Search', params: { scrollY: $route.params.scrollY } }">
              <b-button variant="danger">Chiudi</b-button>
            </router-link>
          </b-col>
        </b-row>
        <!--
        <b-row>
          <b-col sm="12">
            <vue-editor class="text-justify" v-model="commentoInput"
              :editor-toolbar="customToolbar"
              ref="editor"
              placeholder="Copia dalla sentenza sulla sinistra una o più parti di testo in cui riscontri interessanti passaggi di diritto e copiali qui come Massima." />
          </b-col>
          <b-col sm="12" class="mt-1">
            <b-form-textarea
              v-model="premassimaInput"
              class="text-justify"
              placeholder="Riassumi brevemente qui ogni principio di diritto di cui hai fatto copia e incolla nel campo che precede."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
          <b-col sm="12">
            <b-button class="mt-1" variant="outline-success" @click="pubblicaCommento()">Pubblica il commento</b-button>
          </b-col>
        </b-row>
        <hr/>
        <b-row v-if="commenti.length > 0">
          <b-col class="p-2">
            <b>Massime e commenti</b>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" v-for="commento in commenti" :key="commento.id" v-if="commento.approvata" style="font-size: 14px;">
            <commento :input="commento" :showCommenta="false" :showTitoloSentenza="false" :showVisualizzazioni="false"></commento>
          </b-col>
        </b-row>
        -->
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" style="min-height: 90vh;">

        <keep-alive>
          <pdf-tron :src="getPdfUrl()" 
            :searchText="searchText" @update:searchText="searchText = $event"
            :searchOptions="searchOptions" @update:searchOptions="searchOptions = $event" />
        </keep-alive>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import PdfTron from '../PdfTron/PdfTron.vue'
import Commento from '../Sentenza/Commento.vue';

import { VueEditor } from "vue2-editor";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import api from '../../services/service.js'
import searchApi from '../../services/search.js'

import Quill from 'quill';

export default {
  name: 'sentenza',
  components: {
    PdfTron,
    VueEditor,
    Loading,
    Commento
  },
  data () {
    return {
      commentoInput: '',
      premassimaInput: '',
      commenti: [],
      lastUpdate: null,
      loading: false,
      customToolbar: [
        ["bold", "italic", "underline", "strike", { list: "ordered" }, { list: "bullet" }, { color: [] }, { background: [] }]
      ],
      idSentenza: this.$route.params.idNodo,
      me: {},
      numeroVisualizzazioni: '',
      testoRicerca: (this.$route.params.filters ? this.$route.params.filters.query : ""),
      //params for choosing the next and previous sentenza
      showPreviousSentenza: false,
      showNextSentenza: false,
      previousSentenzaParams: {},
      nextSentenzaParams: {},
      numSentenza: null,
      totSentenze: null,
      searchText: this.$route.params.searchText,
      searchOptions: this.$route.params.searchOptions
    }
  },
  methods: {
    getPdfUrl() {
      return api.getBaseUrl() + "cercasentenze/" + this.idSentenza;
    },
    async getCommenti() {
      //get commenti
      this.commenti = await api.execute('get', 'commento/' + this.idSentenza);
    },
    async getVisualizzazioni() {
      this.numeroVisualizzazioni = await api.execute('get', 'cercasentenze/visualizzazioni/' + this.idSentenza);
    },
    pubblicaCommento() {
      if(this.premassimaInput === ''){
        alert("Inserire una premassima nell'apposita casella.");
        return;
      }
      if(this.commentoInput === ''){
        alert("Inserire un testo per il commento nell'apposita casella.");
        return;
      }

      this.loading = true;

      let data = {
        testo: this.commentoInput,
        premassima: this.premassimaInput,
        sentenzaId: this.idSentenza
      }

      //send commento
      api.execute('post', 'commento', data, true).then((resp) => {
        if(resp.status === 201){
          this.getCommenti();
          this.commentoInput = '';
          this.premassimaInput = '';

          let content = `
            Il commento è stato inserito, ma prima di essere visibile è necessario che venga approvato da un amministratore.
            Ricordati inoltre di mantenere aggiornato il tuo profilo. Per aggiornare il tuo profilo adesso clicca QUI.
          `;
          this.$bvToast.toast(content, {
            title: 'Commento inserito!',
            variant: 'primary',
            solid: true,
            autoHideDelay: 15000,
            to: { name: 'ModificaUtente' },
            bodyClass: 'text-decoration-none'
          });

          this.loading = false;
        }
        else{
          this.loading = false;
          alert("Qualcosa è andato storto, riprova o contatta un amministratore per favore.");
        }
      });
    },
    async getProfiloLoggato(){
      let data = await api.execute('get', 'profilo/me');
      this.me = data;
    },
    async getPrevNextSentenze(){
      let type = this.$route.params.type;
      let form = this.$route.params.filters;
      let absIndex = this.$route.params.index;
      if (form === undefined || absIndex === undefined)
        return;
      form.page = Math.floor(absIndex / 20) + 1;
      const searchFunc = type === 'diMerito' ? searchApi.searchDiMerito : searchApi.searchAmministrative;
      let data = await searchFunc(form);
      let sentenze = data.sentenze;
      let myIndex = sentenze.findIndex((x) => x.idNodo === this.idSentenza);
      if (myIndex === 0 && form.page > 1){
        let dataPrev = await searchFunc({...form, page: form.page-1});
        sentenze = [...dataPrev.sentenze, ...sentenze];
      }
      else if (myIndex === sentenze.length - 1){
        try{
          let dataSucc = await searchFunc({...form, page: form.page+1});
          sentenze = [...sentenze, ...dataSucc.sentenze];
        }
        catch(e) {}
      }
      myIndex = sentenze.findIndex((x) => x.idNodo === this.idSentenza);

      this.numSentenza = absIndex + 1;
      this.totSentenze = data.totalNum;

      let scrollY = this.$route.params.scrollY;

      if(!(myIndex === 0 && form.page === 1)){ //not the first sentenza of the first page
        this.previousSentenzaParams = {
          ...sentenze[myIndex-1],
          type: type,
          filters: form,
          index: absIndex-1,
          scrollY: scrollY
        };
        this.showPreviousSentenza = true;
      }
      if(!(absIndex+1 === data.totalNum)){ //not the last sentenza
        this.nextSentenzaParams = {
          ...sentenze[myIndex+1],
          type: type,
          filters: form,
          index: absIndex+1,
          scrollY: scrollY
        };
        this.showNextSentenza = true;
      }
    }
  },
  async created() {
    this.$parent._data.loaded = true;

    //await this.getCommenti();
    await this.getProfiloLoggato();
    await this.getVisualizzazioni();

    //show or hide previous and next sentenza buttons
    this.getPrevNextSentenze();

    let searchText = this.$route.params.searchText;
    let searchOptions = this.$route.params.searchOptions;
    if (searchText !== undefined){
      this.searchText = searchText;
    }
    if (searchOptions !== undefined){
      this.searchOptions = searchOptions;
    }
    console.log("test", this.searchText, this.searchOptions);

    //to clean pasted html from PDF
    /*
    this.$refs.editor.quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        var plaintext = node.innerText.split('\n').join(' ');
        while (plaintext.indexOf('  ') !== -1){
          plaintext = plaintext.split('  ').join(' ');
        }
        var Delta = Quill.import('delta');
        let result = new Delta().insert(plaintext);
        return result;
    });*/
  },
  updated() {
    /*
    var ref = this
    this.$nextTick(function () {
      if(typeof ref.$refs.editor != 'undefined'){
        let el = document.getElementsByClassName("quillWrapper")[0];
        if(el !== undefined)
          el.onkeydown = function(evt) {
            evt = evt.stopPropagation();
          };
      }
    })*/
  },
  watch:{
    $route (to, from){
      /*
      if(to.name === "Sentenza")
        this.getCommenti();

       */
    }
  }
}
</script>

<style>
@import "~vue2-editor/dist/vue2-editor.css";

body {
  font-size: medium !important;
}
.ql-editor{
  min-height: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Sentenza/Sentenza.vue